import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailNewCreditCapacityComponent from './loansDetailNewCreditCapacity.component';

let loansDetailNewCreditCapacityModule = angular.module('loansDetailNewCreditCapacity', [
  uiRouter
])

.component('loansDetailNewCreditCapacity', loansDetailNewCreditCapacityComponent)

.name;

export default loansDetailNewCreditCapacityModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailNewCreditCapacity/loansDetailNewCreditCapacity.js